export default {
    default: [
        {
            hoverControl: false,
            label: 'Animation On Scroll',
            modules: [
                'animation/type',
                {
                    conditions: [
                        ['animation/type', '!=', null],
                        '&&',
                        ['animation/type', '!=', ''],
                    ],
                    modules: [
                        'animation/easing',
                        'animation/duration',
                        'animation/delay',
                        'animation/offset',
                        'animation/once',
                        'animation/mirror',
                        'animation/anchorPlacement',
                    ],
                },
            ],
        },
        {
            hoverControl: false,
            label: 'HTML SELECTORS',
            modules: ['attr/id', { path: 'attr/__data' }],
        },
        {
            hoverControl: false,
            label: 'Hover Transition',
            modules: ['style/transition'],
        },
        {
            hoverControl: false,
            label: 'Visibility & Position',
            modules: [
                'settings/hideOn',
                'style/overflowX',
                'style/overflowY',
                'style/zIndex',
            ],
        },
        {
            hoverControl: false,
            label: 'Custom Style',
            modules: [
                {
                    path: 'advanced/customStyle/general',
                    content: {
                        template: 'Input',
                        label: 'General CSS',
                        inputType: 'textarea',
                    },
                    // validation: {
                    //     validate: (value) => {
                    //         const regx = /[\w-]+:\s?.+;\n?$/gim;
                    //         return regx.test(value);
                    //     },
                    //     message: 'The CSS you entered is invalid',
                    // },
                },
                {
                    path: 'advanced/customStyle/&:before',
                    content: {
                        template: 'Input',
                        label: '`before` CSS',
                        inputType: 'textarea',
                    },
                },
                {
                    path: 'advanced/customStyle/&:after',
                    content: {
                        template: 'Input',
                        label: '`after` CSS',
                        inputType: 'textarea',
                    },
                },
            ],
        },
    ],
    _section: [
        {
            hoverControl: false,
            label: 'Animation On Scroll',
            modules: [
                'animation/type',
                {
                    conditions: [
                        ['animation/type', '!=', null],
                        '&&',
                        ['animation/type', '!=', ''],
                    ],
                    modules: [
                        'animation/easing',
                        'animation/duration',
                        'animation/delay',
                        'animation/offset',
                        'animation/once',
                        'animation/mirror',
                        'animation/anchorPlacement',
                    ],
                },
            ],
        },
        { hoverControl: false, label: 'HTML ID', modules: ['attr/id'] },
        {
            hoverControl: false,
            label: 'Hover Transition',
            modules: ['style/transition'],
        },
        {
            hoverControl: false,
            label: 'Visibility & Position',
            modules: [
                // 'style/display',
                'style/overflowX',
                'style/overflowY',
                'style/zIndex',
            ],
        },
    ],
};
